"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PL = void 0;
exports.PL = {
    numericCode: '616',
    alpha2Code: 'PL',
    alpha3Code: 'POL',
    englishName: {
        short: 'Poland',
        full: 'the Republic of Poland',
    },
    names: {
        full: {
            en: 'the Republic of Poland',
            fr: 'la République de Pologne',
            pl: 'Polska',
        },
        short: {
            en: 'Poland',
            fr: 'Pologne (la)',
            pl: 'Polska',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'pl',
            languageAlpha3Code: 'pol',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'PL-02': {
            numericCode: '616',
            code: 'PL-02',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Dolnośląskie',
            },
        },
        'PL-04': {
            numericCode: '616',
            code: 'PL-04',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Kujawsko-pomorskie',
            },
        },
        'PL-06': {
            numericCode: '616',
            code: 'PL-06',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Lubelskie',
            },
        },
        'PL-08': {
            numericCode: '616',
            code: 'PL-08',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Lubuskie',
            },
        },
        'PL-10': {
            numericCode: '616',
            code: 'PL-10',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Łódzkie',
            },
        },
        'PL-12': {
            numericCode: '616',
            code: 'PL-12',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Małopolskie',
            },
        },
        'PL-14': {
            numericCode: '616',
            code: 'PL-14',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Mazowieckie',
            },
        },
        'PL-16': {
            numericCode: '616',
            code: 'PL-16',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Opolskie',
            },
        },
        'PL-18': {
            numericCode: '616',
            code: 'PL-18',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Podkarpackie',
            },
        },
        'PL-20': {
            numericCode: '616',
            code: 'PL-20',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Podlaskie',
            },
        },
        'PL-22': {
            numericCode: '616',
            code: 'PL-22',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Pomorskie',
            },
        },
        'PL-24': {
            numericCode: '616',
            code: 'PL-24',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Śląskie',
            },
        },
        'PL-26': {
            numericCode: '616',
            code: 'PL-26',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Świętokrzyskie',
            },
        },
        'PL-28': {
            numericCode: '616',
            code: 'PL-28',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Warmińsko-mazurskie',
            },
        },
        'PL-30': {
            numericCode: '616',
            code: 'PL-30',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Wielkopolskie',
            },
        },
        'PL-32': {
            numericCode: '616',
            code: 'PL-32',
            category: {
                id: '217',
                names: {
                    en: {
                        singular: 'voivodship',
                        plural: 'voivodships',
                    },
                    fr: {
                        singular: 'voïvodie',
                        plural: '',
                    },
                    pl: {
                        singular: 'województwo',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pl: 'Zachodniopomorskie',
            },
        },
    },
    cities: [
        {
            name: 'Żyrardów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Żoliborz',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Zielonka',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Zamość',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Zambrów',
            subdivision: 'Podlasie',
        },
        {
            name: 'Ząbki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Wyszków',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Wołomin',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Wola',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Włochy',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Wieliczka',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Wesoła',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Wawer',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Warsaw',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Ursus',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Tomaszów Mazowiecki',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Tomaszów Lubelski',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Tarnów',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Tarnobrzeg',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Targówek',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Szczytno',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Świdnik',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Suwałki',
            subdivision: 'Podlasie',
        },
        {
            name: 'Sulejówek',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Staszów',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Starachowice',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Stalowa Wola',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Śródmieście',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Sokołów Podlaski',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Sokółka',
            subdivision: 'Podlasie',
        },
        {
            name: 'Sochaczew',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Skierniewice',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Skarżysko-Kamienna',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Siemiatycze',
            subdivision: 'Podlasie',
        },
        {
            name: 'Siedlce',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Sanok',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Sandomierz',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Rzeszów',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Ropczyce',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Rembertów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Rawa Mazowiecka',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Radzyń Podlaski',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Radom',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Pułtusk',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Puławy',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Przeworsk',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Przemyśl',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Przasnysz',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Pruszków',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Płońsk',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Pisz',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Pionki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Piastów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Piaseczno',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Otwock',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Ostrów Mazowiecka',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Ostrowiec Świętokrzyski',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Ostrołęka',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Opoczno',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Olsztyn',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Olecko',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Ochota',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Nowy Targ',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Nowy Sącz',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Nowy Dwór Mazowiecki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Nisko',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Mrągowo',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Mokotów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Mława',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Mińsk Mazowiecki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Milanówek',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Mielec',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Międzyrzec Podlaski',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Marki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Łuków',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Lublin',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Lubartów',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Łomża',
            subdivision: 'Podlasie',
        },
        {
            name: 'Łomianki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Lidzbark Warmiński',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Legionowo',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Łęczna',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Łapy',
            subdivision: 'Podlasie',
        },
        {
            name: 'Łańcut',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Krosno',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Krasnystaw',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Kraśnik',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Kozienice',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Konstancin-Jeziorna',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Końskie',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Kobyłka',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Kielce',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Kętrzyn',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Kabaty',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Józefów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Jędrzejów',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Jasło',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Jarosław',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Hrubieszów',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Hajnówka',
            subdivision: 'Podlasie',
        },
        {
            name: 'Grodzisk Mazowiecki',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Grajewo',
            subdivision: 'Podlasie',
        },
        {
            name: 'Gorlice',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Giżycko',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Gierłoż',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Garwolin',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Ełk',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Działdowo',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Dęblin',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Dębica',
            subdivision: 'Subcarpathian Voivodeship',
        },
        {
            name: 'Ciechanów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Chełm',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Busko-Zdrój',
            subdivision: 'Świętokrzyskie',
        },
        {
            name: 'Brzesko',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Bochnia',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Biłgoraj',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Bielsk Podlaski',
            subdivision: 'Podlasie',
        },
        {
            name: 'Bielany',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Białystok',
            subdivision: 'Podlasie',
        },
        {
            name: 'Białołeka',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Biała Podlaska',
            subdivision: 'Lublin Voivodeship',
        },
        {
            name: 'Bemowo',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Bartoszyce',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Augustów',
            subdivision: 'Podlasie',
        },
        {
            name: 'Żywiec',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Żory',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Złotów',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Złotoryja',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Zielona Góra',
            subdivision: 'Lubusz',
        },
        {
            name: 'Zgorzelec',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Zgierz',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Zduńska Wola',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Zawiercie',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Żary',
            subdivision: 'Lubusz',
        },
        {
            name: 'Zakopane',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Żagań',
            subdivision: 'Lubusz',
        },
        {
            name: 'Zabrze',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Ząbkowice Śląskie',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Września',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Wrocław',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Wodzisław Śląski',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Włocławek',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Wieluń',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Wejherowo',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Wałcz',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Wałbrzych',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Wągrowiec',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Wadowice',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Ustroń',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Ustka',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Tychy',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Turek',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Trzebinia',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Trzcianka',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Toruń',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Tczew',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Tarnowskie Góry',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Szczecinek',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Szczecin',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Szamotuły',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Świnoujście',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Świętochłowice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Świebodzin',
            subdivision: 'Lubusz',
        },
        {
            name: 'Świecie',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Świebodzice',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Świdwin',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Świdnica',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Swarzędz',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Sulechów',
            subdivision: 'Lubusz',
        },
        {
            name: 'Strzelce Opolskie',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Strzegom',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Starogard Gdański',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Stargard Szczeciński',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Środa Wielkopolska',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Śrem',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Sosnowiec',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Sopot',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Solec Kujawski',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Słupsk',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Słubice',
            subdivision: 'Lubusz',
        },
        {
            name: 'Skawina',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Sierpc',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Sieradz',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Siemianowice Śląskie',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Rypin',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Rydułtowy',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Rybnik',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Rumia',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Ruda Śląska',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Reda',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Rawicz',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Radzionków',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Radomsko',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Radlin',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Racibórz',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Pyskowice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Pszczyna',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Pruszcz Gdański',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Prudnik',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Poznań',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Polkowice',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Police',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Płock',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Pleszew',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Piotrków Trybunalski',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Piła',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Piekary Śląskie',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Pabianice',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Ozorków',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Oświęcim',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Ostrów Wielkopolski',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Ostróda',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Orzesze',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Opole',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Olkusz',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Oleśnica',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Oława',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Oborniki',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Nysa',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Nowy Tomyśl',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Nowogard',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Nowa Sól',
            subdivision: 'Lubusz',
        },
        {
            name: 'Nowa Ruda',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Namysłów',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Nakło nad Notecią',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Myszków',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Mysłowice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Myślenice',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Mikołów',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Międzyrzecz',
            subdivision: 'Lubusz',
        },
        {
            name: 'Malbork',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Luboń',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Lubliniec',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Lubin',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Lubań',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Łowicz',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Łódź',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Libiąż',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Leszno',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Legnica',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Lędziny',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Łęczyca',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Lębork',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Łaziska Górne',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Łask',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Kwidzyn',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Kutno',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Krotoszyn',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Krapkowice',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Kraków',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Koszalin',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Kostrzyn nad Odrą',
            subdivision: 'Lubusz',
        },
        {
            name: 'Kościerzyna',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Kościan',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Konstantynów Łódzki',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Konin',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Kołobrzeg',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Koło',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Knurów',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Kluczbork',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Kłodzko',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Kęty',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Kędzierzyn-Koźle',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Katowice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Kartuzy',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Kamienna Góra',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Kalisz',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Jelenia Góra',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Jelcz',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Jaworzno',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Jawor',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Jastrzębie Zdrój',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Jarocin',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Inowrocław',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Iława',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Gubin',
            subdivision: 'Lubusz',
        },
        {
            name: 'Gryfino',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Gryfice',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Grudziądz',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Gostynin',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Gostyń',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Gorzów Wielkopolski',
            subdivision: 'Lubusz',
        },
        {
            name: 'Goleniów',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Gniezno',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Głuchołazy',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Głowno',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Głogów',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Gliwice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Gdynia',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Gdańsk',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Fordon',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Elbląg',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Dzierżoniów',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Dąbrowa Górnicza',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Częstochowa',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Czerwionka-Leszczyny',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Czeladź',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Czechowice-Dziedzice',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Cieszyn',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Chrzanów',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Choszczno',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Chorzów',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Chojnice',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Chodzież',
            subdivision: 'Greater Poland Voivodeship',
        },
        {
            name: 'Chełmża',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Chełmno',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Bytów',
            subdivision: 'Pomeranian Voivodeship',
        },
        {
            name: 'Bytom',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Bydgoszcz',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Brzeg',
            subdivision: 'Opole Voivodeship',
        },
        {
            name: 'Brodnica',
            subdivision: 'Kujawsko-Pomorskie',
        },
        {
            name: 'Braniewo',
            subdivision: 'Warmian-Masurian Voivodeship',
        },
        {
            name: 'Bolesławiec',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Boguszów-Gorce',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Bogatynia',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Bieruń',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Bielsko-Biala',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Bielawa',
            subdivision: 'Lower Silesian Voivodeship',
        },
        {
            name: 'Białogard',
            subdivision: 'West Pomeranian Voivodeship',
        },
        {
            name: 'Bełchatów',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Będzin',
            subdivision: 'Silesian Voivodeship',
        },
        {
            name: 'Andrychów',
            subdivision: 'Lesser Poland Voivodeship',
        },
        {
            name: 'Aleksandrów Łódzki',
            subdivision: 'Łódź Voivodeship',
        },
        {
            name: 'Ursynów',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Praga Północ',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Praga Południe',
            subdivision: 'Masovian Voivodeship',
        },
        {
            name: 'Jelcz Laskowice',
            subdivision: 'Lower Silesian Voivodeship',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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